import React, { Component } from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from "redux"
import * as categoryActions from "../../redux/actions/categoryActions"
import "../categories/category.css"
import { Link } from "react-router-dom";
import * as movieActions from "../../redux/actions/movieActions";

class CategoryList extends Component {
    
    componentDidMount(){
        this.props.actions.getCategories()
       
    }
    
    categoryHandler(category,id){
        localStorage.setItem("page2",1)
        this.props.actions.getCategorizedMovies();
        console.log("//////////")
        console.log(this.props.actions.getCategorizedMovies());
        this.props.actions.changeCategory(category);
    }
  
    render() {
        return (
             
            <div className="category_part"> 
                <div>
                    {this.props.categories.map(category => (
                        <Link className="category" key={category.id} to={`/category/${category.id}`}>
                            <button onClick={() => this.categoryHandler(category.name,category.id)} key={category.id} className="mx-3 category">
                                {category.name}
                            </button>
                        </Link>
                    ))}
                    
                </div>
            </div>
        )
    }
}

function mapStateToProps(state){
    return{
        currentCategory:state.changeCategoryReducer,
        categories:state.categoryListReducer,
        categorizedMovies:state.categorizedMoviesReducer
    }
}

function mapDispatchToProps(dispatch){
    return{
        actions:{
            getCategories:bindActionCreators(categoryActions.getCategories,dispatch),
            getCategorizedMovies:bindActionCreators(movieActions.getCategorizedMovies,dispatch),
            changeCategory: bindActionCreators(categoryActions.changeCategory, dispatch)

        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(CategoryList)